/* Scare-Drone Produktseite: Slider, Videos mit Ton, Zaehler, "Mehr anzeigen", Sendungsverfolgung */
(function () {
  if (window.__hlInit) return; window.__hlInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSlider(root) {
    if (root.__hl) return; root.__hl = true;
    var track = root.querySelector('[data-hl-track]');
    var dotsBox = root.querySelector('[data-hl-dots]');
    if (!track) return;
    var items = Array.prototype.filter.call(track.children, function (c) { return c.offsetParent !== null || true; });
    if (dotsBox && items.length > 1) {
      items.forEach(function (it, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { go(i); stop(); });
        dotsBox.appendChild(b);
      });
    }
    function idx() {
      var best = 0, bestD = Infinity, mid = track.scrollLeft + track.clientWidth / 2;
      items.forEach(function (it, i) { var c = it.offsetLeft + it.offsetWidth / 2 - track.offsetLeft; var d = Math.abs(c - mid); if (d < bestD) { bestD = d; best = i; } });
      return best;
    }
    function mark() { if (!dotsBox) return; var a = idx(); Array.prototype.forEach.call(dotsBox.children, function (d, i) { d.setAttribute('aria-current', i === a ? 'true' : 'false'); }); }
    function go(i) { var it = items[i]; if (!it) return; track.scrollTo({ left: it.offsetLeft - track.offsetLeft - (track.clientWidth - it.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }); }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
    mark();
    var timer = null;
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    if (root.classList.contains('hl-mini') && items.length > 1 && !reduce) {
      timer = setInterval(function () { var n = idx() + 1; go(n >= items.length ? 0 : n); }, 5000);
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (e) { track.addEventListener(e, stop, { passive: true }); });
    }
  }

  function initVideos(scope) {
    var vids = scope.querySelectorAll('.hl-vc video');
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.setAttribute('playsinline', ''); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
      }, { threshold: 0.35 });
      vids.forEach(function (v) { io.observe(v); });
    }
    scope.querySelectorAll('[data-hl-sound]').forEach(function (btn) {
      if (btn.__hl) return; btn.__hl = true;
      btn.addEventListener('click', function () {
        var v = btn.parentNode.querySelector('video'); if (!v) return;
        var turnOn = v.muted;
        document.querySelectorAll('.hl-vc video').forEach(function (o) { o.muted = true; });
        document.querySelectorAll('[data-hl-sound]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'Turn sound on'); });
        if (turnOn) { v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () {}); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Turn sound off'); }
      });
    });
  }

  function initMore(scope) {
    scope.querySelectorAll('[data-hl-more]').forEach(function (btn) {
      if (btn.__hl) return; btn.__hl = true;
      btn.addEventListener('click', function () {
        var sec = btn.closest('.hl-sec'); var g = sec && sec.querySelector('[data-hl-more-grid]');
        if (g) g.classList.add('is-open');
        btn.parentNode.remove();
      });
    });
  }

  function countUp(el) {
    var txt = el.textContent.trim();
    var m = txt.match(/^(\d{1,6})(.*)$/);
    if (!m || reduce) return;
    var to = parseInt(m[1], 10), rest = m[2], t0 = null, dur = 1200;
    function step(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / dur); var e = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(to * e) + rest; if (p < 1) requestAnimationFrame(step); }
    el.textContent = '0' + rest; requestAnimationFrame(step);
  }

  function initReveal(scope) {
    var rv = scope.querySelectorAll('.hl-rv:not(.is-in)');
    var counts = scope.querySelectorAll('[data-hl-count]');
    if (!('IntersectionObserver' in window)) { rv.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el);
        if (el.classList.contains('hl-rv')) el.classList.add('is-in');
        if (el.hasAttribute('data-hl-count') && !el.__hlc) { el.__hlc = true; countUp(el); }
      });
    }, { threshold: 0.25 });
    rv.forEach(function (e) { io.observe(e); });
    counts.forEach(function (e) { io.observe(e); });
  }

  function initTrack(scope) {
    scope.querySelectorAll('[data-hl-track-form]').forEach(function (f) {
      if (f.__hl) return; f.__hl = true;
      f.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var v = (f.querySelector('input[name="nums"]').value || '').trim();
        if (!v) return;
        window.open('https://t.17track.net/en#nums=' + encodeURIComponent(v), '_blank', 'noopener');
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-hl-slider]').forEach(initSlider);
    initVideos(scope); initMore(scope); initReveal(scope); initTrack(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
